import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { TooltipHost, mergeStyles } from 'office-ui-fabric-react/lib';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    getCurrentThemeId,
    isCssVariablesSupported,
    themeSupportsDarkMode,
    getCobrandingThemeResources,
    ThemeConstants,
    getShouldShowOfficeTheme,
} from 'owa-theme';
import { getIsDarkTheme } from 'owa-fabric-theme';

export interface ThemeSwatchProps {
    themeId: string;
    onClick?: (themeId: string) => void;
}

interface DumbThemeSwatchProps extends ThemeSwatchProps {
    title: string;
    swatchStyle: string;
}

const styles = require('./Theme.scss');
const classNames = require('classnames/bind').bind(styles);
const spriteStyles = require('owa-sprite/dist/styles/theme_sprite.css');

export default (props: ThemeSwatchProps) => {
    switch (props.themeId) {
        case ThemeConstants.BASE_THEME_ID:
            return <BaseThemeSwatch {...props} />;
        case ThemeConstants.BASE_OFFICE_THEME_ID:
            return <BaseWithOfficePreferredThemeSwatch {...props} />;
        default:
            return <StandardThemeSwatch {...props} />;
    }
};

@observer
class StandardThemeSwatch extends React.Component<ThemeSwatchProps, {}> {
    render() {
        const { themeId } = this.props;

        return (
            <DumbThemeSwatch
                {...this.props}
                title={strings[`themeDisplayName_${themeId}`]}
                swatchStyle={spriteStyles[`theme-icon-${themeId}`]}
            />
        );
    }
}

@observer
class BaseWithOfficePreferredThemeSwatch extends React.Component<ThemeSwatchProps, {}> {
    render() {
        let useOfficeTheme = getShouldShowOfficeTheme() && !isConsumer();
        return (
            <DumbThemeSwatch
                {...this.props}
                themeId={
                    useOfficeTheme
                        ? ThemeConstants.BASE_OFFICE_THEME_ID
                        : ThemeConstants.BASE_THEME_ID
                }
                title={
                    useOfficeTheme
                        ? strings.themeDisplayName_base
                        : strings.themeDisplayName_cobranding
                }
                swatchStyle={
                    useOfficeTheme
                        ? spriteStyles[`theme-icon-${ThemeConstants.BASE_OFFICE_THEME_ID}`]
                        : spriteStyles[`theme-icon-${ThemeConstants.BASE_THEME_ID}`]
                }
            />
        );
    }
}

@observer
class BaseThemeSwatch extends React.Component<ThemeSwatchProps, {}> {
    render() {
        if (getShouldShowOfficeTheme()) {
            return (
                <DumbThemeSwatch
                    {...this.props}
                    title={strings.themeDisplayName_cobranding}
                    swatchStyle={mergeStyles({
                        backgroundColor: getCobrandingThemeResources().themePalette
                            .headerBackground,
                    })}
                />
            );
        } else {
            return <BaseWithOfficePreferredThemeSwatch {...this.props} />;
        }
    }
}

@observer
class DumbThemeSwatch extends React.Component<DumbThemeSwatchProps, {}> {
    render() {
        const { themeId, title, swatchStyle } = this.props;

        const isChecked = themeId === getCurrentThemeId();
        const isDisabled =
            getIsDarkTheme() && isCssVariablesSupported() && !themeSupportsDarkMode(themeId);

        return (
            <TooltipHost content={isDisabled ? strings.theme_disabled_dark_mode_tooltip : ''}>
                <div
                    className={classNames(styles.swatch, {
                        selected: isChecked,
                        disabled: isDisabled,
                    })}
                    onClick={this.onClick}
                    data-is-focusable="true"
                    role="option"
                    aria-checked={isChecked}
                    aria-label={title}
                    title={title}>
                    <i className={classNames(swatchStyle, styles.image)} />
                </div>
            </TooltipHost>
        );
    }

    private onClick = (ev: React.MouseEvent<HTMLDivElement>) => {
        ev.stopPropagation();
        if (this.props.onClick) {
            this.props.onClick(this.props.themeId);
        }
    };
}
